// frontend/src/components/automation/TestResults.jsx
import React from 'react'
import { CheckCircle, XCircle, Clock, AlertCircle } from 'lucide-react'

const TestResults = ({ results = [] }) => {
  if (results.length === 0) {
    return (
      <div className="text-center text-gray-500 py-4">
        <AlertCircle className="h-8 w-8 mx-auto mb-2 text-gray-300" />
        <p className="text-sm">No test results yet</p>
      </div>
    )
  }

  const getStatusIcon = (status) => {
    switch (status) {
      case 'passed': return <CheckCircle className="h-4 w-4 text-emerald-500" />
      case 'failed': return <XCircle className="h-4 w-4 text-red-500" />
      default: return <Clock className="h-4 w-4 text-gray-400" />
    }
  }

  const getStatusColor = (status) => {
    switch (status) {
      case 'passed': return 'text-emerald-600 bg-emerald-50 border-emerald-200'
      case 'failed': return 'text-red-600 bg-red-50 border-red-200'
      default: return 'text-gray-600 bg-gray-50 border-gray-200'
    }
  }

  return (
    <div className="space-y-2">
      {results.map((result, index) => (
        <div
          key={index}
          className={`p-3 border rounded-lg ${getStatusColor(result.status)}`}
        >
          <div className="flex items-center space-x-2 mb-1">
            {getStatusIcon(result.status)}
            <span className="font-medium text-sm">
              {result.test_case?.test_name || result.test_case?.name || `Test ${index + 1}`}
            </span>
          </div>
          <p className="text-xs opacity-75">
            {result.test_case?.description || result.description || 'No description'}
          </p>
          {result.execution_time && (
            <p className="text-xs mt-1 opacity-60">
              Execution time: {result.execution_time}s
            </p>
          )}
          {result.error && (
            <p className="text-xs mt-1 text-red-600 bg-red-100 rounded px-2 py-1">
              Error: {result.error}
            </p>
          )}
        </div>
      ))}
    </div>
  )
}

export default TestResults